import {
  Lexend_400Regular,
  Lexend_500Medium,
  Lexend_600SemiBold,
  Lexend_700Bold,
} from "@expo-google-fonts/lexend";

export const appFonts = {
  Lexend: Lexend_400Regular,
  LexendMedium: Lexend_500Medium,
  LexendSemiBold: Lexend_600SemiBold,
  LexendBold: Lexend_700Bold,
};
